<template>
  <div class='sub-page'>
    <div class='sub-tab-wrap'>
      <DxTabPanel
          id="tabpanel"
          :selected-index.sync="selectedIndex"
          :data-source='tabs'
          :focusStateEnabled='true'
        >
        <template #title="{ data: tab }">
        <div class='sub-title-wrap-tab'>
          <ul>
            <li class='float-left sub-title'>{{tab.title}}</li>
          </ul>
          </div>
        </template>
      </DxTabPanel>
    </div>

    <div class='sub-content'> <!-- 여기까지 page header 이하 수정해서 사용-->
      <DxToolbar>
        <DxItem
          #default
          location="before"
          locate-in-menu="never"
        >
          <div class="toolbar-label"><b>년도 : </b></div>
        </DxItem>
        <DxItem
          :options="selectBoxYearOptions"
          location="before"
          locate-in-menu="auto"
          widget="dxSelectBox"
        />
        </DxToolbar>
      <div id="chart-demo">
        <DxChart
          id="chart"
          :data-source="productChart"
          palette="Office"
          title="판매생산 현황"
        >
          <DxCommonSeriesSettings
            type="spline"
            argument-field="생산월"
          />
          <DxSeries
            :bar-padding='0.2'
            name="월계획금액"
            value-field="월계획금액"
            axis="amount"
            type="bar"

          />
          <DxSeries
            :bar-padding='0.2'
            name="월실적금액"
            value-field="월생산금액"
            axis="amount"
            type="bar"

          />
          <DxSeries
            :bar-padding='0.2'
            name="월출하금액"
            value-field="월출하금액"
            axis="amount"
            type="bar"

          />
          <DxSeries
            :bar-padding='0.2'
            name="달성률"
            value-field="달성률"
            axis="rate"
            type="spline"

          />
          <DxCommonAxisSettings>
            <DxGrid :visible="true"/>
          </DxCommonAxisSettings>
          <DxValueAxis
            name="amount"
            position="left"
          />
          <DxValueAxis
            :tick-interval="10"
            :show-zero="true"
            :value-margins-enabled="false"
            name="rate"
            position="right"
          >
          </DxValueAxis>
          <DxMargin :bottom="20"/>
          <DxArgumentAxis
            :allow-decimals="false"
            :axis-division-factor="30"
          >
            <DxLabel>
              <DxFormat type="decimal"/>
            </DxLabel>
          </DxArgumentAxis>
          <DxLegend
            vertical-alignment="top"
            horizontal-alignment="right"
          />
          <DxExport
            :enabled="true"
            title="연생산현황"
            />
          <DxTooltip
            :enabled="true"
            :shared="true"
            :customize-tooltip="customizeTooltipPie"
          />
        </DxChart>
      </div>
      <div>
        <DxToolbar class=‘select-group’ style=‘margin-left:0;’>
          <DxItem
            #default
            location=“after”
            locate-in-menu=“never”
          >
            <div class=“toolbar-label” style=‘color:red;’>(금액:천원)</div>
          </DxItem>
        </DxToolbar>
        <DxPivotGrid
          ref="refPivot"
          :allow-sorting-by-summary="true"
          :allow-sorting="true"
          :allow-filtering="true"
          :allow-expand-all="true"
          :show-borders="true"
          :show-column-grand-totals="false"
          :show-row-grand-totals="false"
          :show-row-totals="false"
          :show-column-totals="true"
          :data-source="dataSource"
          @cell-prepared = 'onCellPrepared'
          @exporting="onExporting"
        >
          <DxFieldChooser
            :enabled="false"
            :height="400"
          />
          <DxExport
            :enabled="true"
            :file-name="excelTitle"
          />
        </DxPivotGrid>
      </div>
      <loading :active.sync="isLoading" color='rgb(2, 110, 156)' loader='bars'></loading>
    </div> <!--sub-conten end-->

  </div>
</template>

<script>
import Loading from 'vue-loading-overlay'
import DxTabPanel from 'devextreme-vue/tab-panel'
import ConstDef from '../../share/ConstDef'
import AppLib from '../../share/AppLib'
import axios from 'axios'
import {
  DxChart,
  DxSeries,
  DxValueAxis,
  DxArgumentAxis,
  DxCommonSeriesSettings,
  DxCommonAxisSettings,
  DxGrid,
  DxExport,
  DxLegend,
  DxMargin,
  DxTooltip,
  DxLabel,
  DxFormat
} from 'devextreme-vue/chart'
import { DxPivotGrid, DxFieldChooser
// , DxExport
} from 'devextreme-vue/pivot-grid'
// import { DxTooltip } from 'devextreme-vue/tooltip'
import PivotGridDataSource from 'devextreme/ui/pivot_grid/data_source'
import DxToolbar, { DxItem } from 'devextreme-vue/toolbar'
// import { DxButton } from 'devextreme-vue'
// excel export 관련 lib
import { Workbook } from 'exceljs'
import { saveAs } from 'file-saver-es'
import { exportPivotGrid } from 'devextreme/excel_exporter'

export default {
  name: 'ProductChart',
  data: function () {
    return {
      isLoading: false,
      userInfo: null,
      gridHeight: null,
      selectedIndex: 0,
      tabs: [
        {
          title: '생산실적'
        }
      ],
      productChart: [],
      selectBoxYearOptions: null,
      selectBoxMonthOptions: null,
      thisYear: null,
      monthlyData: [],
      dataSource: null,
      excelTitle: null,
      pivotGirdData: [],
      resultSum: null,
      planSum: null
    }
  },
  components: {
    Loading,
    DxTabPanel,
    DxChart,
    DxValueAxis,
    DxSeries,
    DxArgumentAxis,
    DxCommonSeriesSettings,
    DxCommonAxisSettings,
    DxGrid,
    DxExport,
    DxLegend,
    DxMargin,
    DxTooltip,
    DxLabel,
    DxFormat,
    DxToolbar,
    DxItem,
    DxPivotGrid,
    DxFieldChooser
  },
  created () {
    document.title = ConstDef.WEB_TAB_TITLE
    this.userInfo = this.$store.getters.getUserInfo
    if (this.userInfo === null) {
      this.$router.push('/')
    }
    this.init()
  },
  mounted () {
    this.gridHeight = (screen.height - 250) * 0.95
  },
  updated () {
  },
  beforeDestroy: function () {

  },
  methods: {
    calcRate (pivotGirdData) {
      let timeStamp
      for (let i = 0; i < this.selectBoxMonthOptions.items.length; i++) {
        timeStamp = `${this.thisYear}-${this.selectBoxMonthOptions.items[i].value}-01`
        let 실적 = this.$_.findWhere(pivotGirdData, { 생산월: timeStamp, 구분: '2.실적' })
        let 계획 = this.$_.findWhere(pivotGirdData, { 생산월: timeStamp, 구분: '1.계획' })
        if (실적 !== undefined && 계획 !== undefined) {
          if (실적.월생산금액 !== undefined && 계획.월생산금액 !== undefined) {
            let 달성수치 = (실적.월생산금액 / 계획.월생산금액) * 100
            const temp = {
              그룹: '생산',
              구분: '3.달성률',
              생산월: timeStamp,
              월생산금액: Math.floor(달성수치)
            }
            pivotGirdData.push(temp)
          }
        }
      }
      return null
    },
    customizeTooltipPie () {
      return ''
    },
    getDate (date) {
      return AppLib.formatDateTimeFromTimeStamp(date)
    },
    init () {
      this.thisYear = AppLib.getThisYear()
      this.selectedMonth = AppLib.getThisMonth()

      let tempArray = []
      for (let i = this.thisYear; i >= 2020; i--) {
        tempArray.push({ 'year': i })
      }
      this.selectBoxYearOptions = {
        width: 70,
        items: tempArray,
        valueExpr: 'year',
        displayExpr: 'year',
        value: this.thisYear,
        onValueChanged: (args) => {
          this.thisYear = args.value
          this.refreshPivotGrid(this.thisYear)
        }
      }
      tempArray = []
      for (let i = 1; i <= 12; i++) {
        if (i > 0 && i < 10) {
          tempArray.push({ 'name': i + '월', value: '0' + i })
        } else {
          tempArray.push({ 'name': i + '월', value: '' + i })
        }
      }
      // makeMonth 할때 사용
      this.selectBoxMonthOptions = {
        width: 70,
        items: tempArray,
        valueExpr: 'value',
        displayExpr: 'name',
        value: this.selectedMonth,
        onValueChanged: (args) => {
          this.selectedMonth = args.value
          this.refreshPivotGrid(this.thisYear)
        }
      }
      this.refreshPivotGrid(this.thisYear)
    },
    onToolbarPreparing (e) {
      //
    },
    onCellPrepared (e) {
      if (e.area === 'data') {
        if (e.cell.value === 0) {
          this.$Q(e.cellElement).find('span').text('')
        }
        if (e.cell.rowPath[1] === '1.계획' && e.cell.columnType === 'T') {
          this.planSum = e.cell.value
        }
        if (e.cell.rowPath[1] === '2.실적' && e.cell.columnType === 'T') {
          this.resultSum = e.cell.value
        }
        if (e.cell.rowPath[1] === '3.달성률' && e.cell.columnType === 'T') {
          const rate = (this.resultSum / this.planSum) * 100
          this.$Q(e.cellElement).css('color', 'blue')
          this.$Q(e.cellElement).find('span').text(`${Math.round(rate)}%`)
        }
        if (e.cell.rowPath[1] === '3.달성률' && e.cell.columnType === 'D') {
          this.$Q(e.cellElement).css('color', 'blue')
          this.$Q(e.cellElement).find('span').text(e.cell.value === undefined ? '' : `${e.cell.value}%`)
        }
      }
    },
    /* ==============START EXCEL EXPORT============ */
    onExporting (e) {
      const workbook = new Workbook()
      const worksheet = workbook.addWorksheet(this.excelTitle)
      exportPivotGrid({
        component: e.component,
        worksheet,
        customizeCell: ({ pivotCell, excelCell }) => {
          console.log(excelCell)
          console.log(excelCell._row._number)
          if (excelCell._value.model.value === 0) {
            excelCell._value.model.value = ''
          }
          if (excelCell._row._number === 5) {
            if (excelCell._value.model.value > 0) {
              Object.assign(excelCell, { font: { color: { argb: '0000FF' }, bold: false } })
            }
          }
        }
      }).then(() => {
        workbook.xlsx.writeBuffer().then((buffer) => {
          saveAs(new Blob([buffer], { type: 'application/octet-stream' }), `${this.excelTitle}.xlsx`)
        })
      })
      e.cancel = true
    },
    /* ==============END EXCEL EXPORT============ */
    refreshPivotGrid (year) {
      const param = { fromDate: `${year}-01-01`, toDate: `${year}-12-31 23:59:59` }
      const 월토탈 = this.$_sp.runNoEncodeFindProc('spFindAll월생산실적ByDate', param)
      this.excelTitle = `${year}년 생산현황`
      axios.all([월토탈])
        .then(axios.spread((...reponse) => {
          this.pivotGirdData = this.$_sp.MakeModel(reponse[0])
          this.makeMonthly(this.pivotGirdData)
          this.calcRate(this.pivotGirdData)
          this.setInitDataSource()
          this.makeChartData()
        })
        )
    },
    makeChartData () {
      this.productChart = []
      let timeStamp
      for (let i = 0; i < this.selectBoxMonthOptions.items.length; i++) {
        timeStamp = `${this.thisYear}-${this.selectBoxMonthOptions.items[i].value}-01`
        let 실적 = this.$_.findWhere(this.pivotGirdData, { 생산월: timeStamp, 구분: '2.실적' })
        let 계획 = this.$_.findWhere(this.pivotGirdData, { 생산월: timeStamp, 구분: '1.계획' })
        let 출하 = this.$_.findWhere(this.pivotGirdData, { 생산월: timeStamp, 구분: '4.출하' })
        let 달성수치 = 0
        let temp
        if (실적 !== undefined && 계획 !== undefined) {
          달성수치 = Math.floor((실적.월생산금액 / 계획.월생산금액) * 100)
        }
        temp = {
          구분: '통합',
          생산월: `${timeStamp.split('-')[1]}월`,
          월계획금액: 계획 !== undefined ? 계획.월생산금액 : 0,
          월생산금액: 실적 !== undefined ? 실적.월생산금액 : 0,
          월출하금액: 출하 !== undefined ? 출하.월생산금액 : 0,
          달성률: 달성수치 !== 0 ? 달성수치 : null
        }
        this.productChart.push(temp)
      }
      // this.productChart = this.$_.sortBy(this.productChart, '생산월')
    },
    makeMonthly (pivotGirdData) {
      let timeStamp
      console.log(pivotGirdData)
      for (let i = 0; i < this.selectBoxMonthOptions.items.length; i++) {
        timeStamp = `${this.thisYear}-${this.selectBoxMonthOptions.items[i].value}-01`
        let where = this.$_.findWhere(pivotGirdData, { 발생일: timeStamp })
        if (where === undefined) {
          const temp = {
            그룹: '생산',
            구분: '1.계획',
            생산월: timeStamp
          }
          pivotGirdData.push(temp)
        }
      }
    },
    setInitDataSource () {
      this.dataSource = new PivotGridDataSource({
        fields: [
          {
            caption: '그룹',
            dataField: '그룹',
            area: 'row',
            width: '100',
            expanded: true
          },
          {
            caption: '구분',
            dataField: '구분',
            area: 'row',
            width: '100',
            expanded: true
          },
          {
            dataField: '생산월',
            dataType: 'date',
            area: 'column',
            groupInterval: 'year',
            expanded: true
          },
          {
            dataField: '생산월',
            dataType: 'date',
            area: 'column',
            groupInterval: 'month',
            expanded: true
          },
          {
            caption: '금액',
            dataField: '월생산금액',
            dataType: 'number',
            summaryType: 'sum',
            format: '#,##0',
            area: 'data'
          }
        ],
        store: this.pivotGirdData
      })
    }
  }
}
</script>

<style lang="scss">

</style>
